<template>
  <div>
      <!-- {{assignment}} -->
      <p>{{ assignment.question_section_title }}</p>
      <p>{{ assignment.question_section_description }}</p>
  </div>
</template>

<script>
export default {
  props:{
    value:{
      type:Object,
      required:true
    }
  },

  computed: {
    assignment: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
